function NewQuery(searchTerm, currentPage, labelsPerPage) {
  return {
    "query": {
      "function_score": {
        "query": {
          "bool": {
            "should": [
              {
                "match": {
                  "label.ngram": {
                    "query": searchTerm,
                    "boost": 10,
                    "_name": "ngram search * score_multiply_10"
                  }
                }
              },
              {
                "match": {
                  "label.strip_whitespace": {
                    "query": searchTerm,
                    "boost": 10,
                    "_name": "exact match * score_multiply_10"
                  }
                }
              },
              {
                "bool": {
                  "must": [
                    {
                    "multi_match": {
                      "query": searchTerm,
                      "fields": [
                        "label.transform1",
                        "label.transform2"
                      ]
                    }
                   }
                ],
                "boost": 2,
                "_name": "transform exact match * score_multiply_2"
                }
              },
              {
                "bool": {
                  "must": [
                    {
                      "multi_match": {
                        "query": searchTerm,
                        "fields": [
                          "label.first_two_chars",
                          "label.first_char_double"
                        ]
                      }
                    },
                    {
                      "multi_match": {
                        "query": searchTerm,
                        "fields": ["label"]
                      }
                    }
                  ],
                  "boost": 6,
                  "_name": "(BB or BE) and BEN * score_multiply_6"
                }
              },
              {
                "bool": {
                  "must": [
                    {
                      "multi_match": {
                        "query": searchTerm,
                        "fields": ["label"]
                      }
                    }
                  ],
                  "boost": 4,
                  "_name": "BEN * score_multiply_4"
                }
              },
              {
                "bool": {
                  "must": [
                    {
                      "match": {
                        "label.first_two_chars": searchTerm
                      }
                    },
                    {
                      "multi_match": {
                        "query": searchTerm,
                        "fields": [
                          "label.last_3_chars_triple_last",
                          "label.last_3_chars_double_last",
                          "label.last_3_chars_double_penultimate"
                        ]
                      }
                    }
                  ],
                  "boost": 4,
                  "_name": "BE and (NNN or ENN or EEN) * score_multiply_4"
                }
              },
              {
                "bool": {
                  "must": [
                    {
                      "multi_match": {
                        "query": searchTerm,
                        "fields": [
                          "label.first_char_double",
                          "label.first_two_chars"
                        ]
                      }
                    },
                    {
                      "multi_match": {
                        "query": searchTerm,
                        "fields": [
                          "label.last_2_chars",
                          "label.last_2_chars_drop_last_keep_first_two"
                        ]
                      }
                    }
                  ],
                  "boost": 2,
                  "_name": "(BB or BE) and (*EN or EN*) * score_multiply_10"
                }
              },
              {
                "bool": {
                  "must": [
                    {
                      "multi_match": {
                        "query": searchTerm,
                        "fields": [
                          "label.first_char_transform1_search_fourth_char",
                          "label.first_char_transform2_search_fourth_char"
                        ]
                      }
                    },
                    {
                      "multi_match": {
                        "query": searchTerm,
                        "fields": [
                          "label.last_3_chars_plus_s",
                          "label.last_3_chars_double_penultimate"
                        ]
                      }
                    }
                  ],
                  "boost": 2,
                  "_name": "***transform(B) and (ENS or ENN) * score_multiply_10"
                }
              },
              {
                "bool": {
                  "must": [
                    {
                      "multi_match": {
                        "query": searchTerm,
                        "fields": [
                          "label.first_char_transform1_search_third_char",
                          "label.first_char_transform2_search_third_char"
                        ]
                      }
                    },
                    {
                      "multi_match": {
                        "query": searchTerm,
                        "fields": [
                          "label.last_3_chars_triple_last",
                          "label.last_3_chars_plus_s",
                          "label.last_3_chars_double_penultimate"
                        ]
                      }
                    }
                  ],
                  "boost": 2,
                  "_name": "**transform(B) and (NNN or ENS or ENN) * score_multiply_10"
                }
              }
            ],
            "filter": [
              {
                "term": {
                  "available": "true"
                }
              }
            ],
            "minimum_should_match": 1
          }
        },
        "functions": [
          {
            "filter": {
              "term": {
                "supplier_id": "19"
              }
            },
            "weight": 2
          }
        ],
        "score_mode": "multiply",
        "boost_mode": "multiply"
      }
    },
    "size": labelsPerPage,
    "from": (currentPage - 1) * labelsPerPage,
    "track_total_hits": true
  };
}

export default NewQuery;
